import { Invoice } from 'dashboard/models/invoice';
import { InvoicesActions, InvoicesActionType } from 'dashboard/redux/actions/invoices';

export interface InvoicesState {
  invoices: Invoice[];
}

const initialInvoicesState: InvoicesState = {
  invoices: [],
};

export default (state: InvoicesState = initialInvoicesState, action: InvoicesActions) => {
  switch (action.type) {
    case InvoicesActionType.SetInvoices: {
      return {
        ...state,
        invoices: action.payload.invoices,
      };
    }

    default:
      return state;
  }
};
